import { IconChainLink, IconSignature } from '@sequencehq/core-components'
import { ContractReferenceType } from 'Cube/domain/cube.domain.types'
import salesforceLogo from 'Integrations/integrationsConfig/salesforce/salesforceLogo.svg'
import netsuiteLogo from 'Integrations/integrationsConfig/netsuite/netsuiteLogo.svg'
import { FC } from 'react'
import styled from 'styled-components'

/** The order references are shown in on a phase, and offered in the menu. */
export const CONTRACT_REFERENCE_TYPES: ReadonlyArray<ContractReferenceType> = [
  'SEQUENCE_QUOTE',
  'SALESFORCE_OPPORTUNITY',
  'NETSUITE',
  'OTHER'
]

export const CONTRACT_REFERENCE_TYPE_CONFIG: Record<
  ContractReferenceType,
  { label: string; Icon: FC }
> = {
  SEQUENCE_QUOTE: {
    label: 'Sequence quote',
    Icon: () => <IconSignature />
  },
  SALESFORCE_OPPORTUNITY: {
    label: 'Salesforce opportunity',
    Icon: () => <Logo src={salesforceLogo} alt="" />
  },
  NETSUITE: {
    label: 'NetSuite contract tag',
    Icon: () => <Logo src={netsuiteLogo} alt="" />
  },
  OTHER: {
    label: 'Other reference',
    Icon: () => <IconChainLink />
  }
}

const Logo = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`
